<template>
	<AppContentLayout>
		<div class="display-flex flex-stretch-to-scroll height-100">
			<div class="page-left-side">
				<PrimaryButton @click="newProcessBtnHandler">New process</PrimaryButton>

				<LoaderWrapper :isLoading="loading">
					<div v-if="processes?.length">
						<perfect-scrollbar>
							<v-list>
								<v-list-item-group active-class="border">
									<v-list-item v-for="proc in processes" :key="proc.processId" @click="setSelectedItem(proc)">
										<v-list-item-content>
											<v-list-item-title>{{ proc.title }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</perfect-scrollbar>
					</div>

					<div v-else>No processes found</div>
				</LoaderWrapper>
			</div>
			<div class="vertical-divider" />
			<router-view></router-view>
		</div>
	</AppContentLayout>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { PROCESSES_ROUTE_NAME } from '@/router/router.const.js';
import AppContentLayout from '../AppLayout/AppContentLayout';
import { loading, processes } from '@/store/modules/processes/getters';
import { loadProcesses, createProcess } from '@/store/modules/processes/actions';
import { projectsList } from '@/store/modules/projects/getters';
import { id as selectedProcessId } from '@/store/modules/selectedProcess/getters';
import { load as loadProcess } from '@/store/modules/selectedProcess/actions';

export default {
	name: 'Processes',
	components: {
		AppContentLayout,
	},
	computed: {
		...mapGettersShorthand({ loading, processes, selectedProcessId, projectsList }),
	},
	methods: {
		...mapActionsShorthand({ loadProcesses, loadProcess, createProcess }),
		async setSelectedItem({ id }) {
			if (this.$route.name === PROCESSES_ROUTE_NAME || id != this.selectedProcessId) {
				this.$router.push({ name: 'Process', params: { processId: id } });
				await this.loadProcess({ id });
			}
		},
		async newProcessBtnHandler() {
			const project = this.projectsList?.[0]?.id;
			if (!project) {
				throw new Error('Unable to retrieve space');
			}
			const { id } = await this.createProcess({ project });
			await this.loadProcess({ id });
			this.$router.push({ name: 'Process', params: { processId: id } });
		},
	},
	mounted() {
		this.loadProcesses();
	},
};
</script>
